import * as React from "react"
import { Box, Grid, Typography } from "@mui/material"
import { CarouselSeeker, IconSeeker } from "@ui-seeker/core"

import {isLoadingCommonFilters} from "@signals";
import StockSummarySkeleton from "./Skeleton"
import StockSummaryWidget from "./Widget"


/**
 * One row of summary widgets. `rows` and `isLoading` come from the page, which asks for the
 * three splits in a single request (see `@hooks/useSummary`).
 */
export default function StockAssortmentDetailsSummary({ rows = [], isLoading, splitKpi, title, labelFormat, showSkuInfo }) {

    if (isLoading || isLoadingCommonFilters.value)  return <StockSummarySkeleton />
    if (!rows.length) return <></>

    return <Grid container spacing={3}>
        <Grid item xs={12}>
            <Box borderBottom="1px solid" borderColor="primary.main" display="flex" justifyContent="space-between">
                <Typography>
                    {title}
                </Typography>
            </Box>
        </Grid>
        <Grid item xs={12}>
            <CarouselSeeker
                responsive={{ desktop: { items: 4 } }}
                centerMode
            >
                {rows.map((row, idx) => <StockSummaryWidget
                    key={idx}
                    row={row}
                    position={idx}
                    showSkuInfo={showSkuInfo}
                    label={row.label}
                    labelFormat={labelFormat}
                    percentage={row.percentage}
                    numSkus={row.numSkus}
                    numDistinctSkus={row.numDistinctSkus}
                    skuScope={row.skuScope}
                    assortment={row.assortment}
                    splitKpi={splitKpi}
                />)}
            </CarouselSeeker>
        </Grid>
    </Grid>
}